var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxboldcaseManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "{props.color}",
    d: "M19.4,3.9c-0.5-0.2-1.1-0.2-1.6-0.2h-3.6c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1 c-0.5-0.7-1.3-1.7-1.3-1.7c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.3,0.2-0.3c1,0,3.2,0,3.2,0c1.8,0,3.4,1,4.2,2.5 C20.1,3.9,20,4,19.8,4C19.7,3.9,19.5,3.9,19.4,3.9L19.4,3.9z M19.2,5.4c-0.4-0.1-0.8-0.2-1.2-0.2h-4c-0.6,0-0.7-0.1-1-0.5l-1.5-2 c-0.7-0.9-1.3-1.5-3-1.5H6C3.4,1.3,1.2,3.4,1.2,6v12c0,2.6,2.1,4.8,4.8,4.8h12c2.6,0,4.8-2.1,4.8-4.8v-8c0-1.6-0.8-3-2-3.9 C20.3,5.8,19.8,5.5,19.2,5.4L19.2,5.4z M9.6,11.8v0.7h4.9v-0.7c0-1.6-0.4-2.4-2.4-2.4S9.6,10.2,9.6,11.8L9.6,11.8z M12,17.2 c-0.7,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2C13.2,16.7,12.6,17.2,12,17.2L12,17.2z M14.7,19.7H9.3 c-2.4,0-3.1-0.7-3.1-3.1v-1.1c0-1.8,0.4-2.7,1.7-3v-0.8c0-1,0-4,4-4s4,3,4,4v0.8c1.3,0.3,1.7,1.1,1.7,3v1.1 C17.8,19,17,19.7,14.7,19.7L14.7,19.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldcaseManager);
export default __webpack_public_path__ + "static/media/vuesaxboldcase-manager.33aebdf2418028d733a9dff532777fee.svg";
export { ForwardRef as ReactComponent };